import styled from 'styled-components'
import Path from '../../../../../static/steam-img/path.png'

export const Hero = styled.div`
  background: ${p => p.theme.webMktPalette.background.gray};

  .Hero__Breadcrumb {
    margin-bottom: 48px;
    ${p => p.theme.breakpoints.down('sm')} {
      margin-bottom: 32px;
    }
  }

  h1 {
    margin: 0;
  }

  h6 {
    margin-top: 8px;
    ${p => p.theme.breakpoints.down('md')} {
      margin-top: 11px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      margin-top: 8px;
    }
  }

  .Hero__Body {
    margin: 24px 0 0;
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: -0.5px;
  }

  .Hero__Inner-Container {
    padding-bottom: 48px;
    ${p => p.theme.breakpoints.down('xs')} {
      padding-bottom: 32px;
    }
  }

  .Hero__Outer-Container {
    max-height: 391px;
    padding: 24px 16px 0px;
    position: relative;

    ${p => p.theme.breakpoints.down('sm')} {
      padding-top: 16px;
    }

    &:before {
      content: '';
      position: absolute;
      background-image: radial-gradient(#696969 1px, transparent 0);
      background-size: 40px 40px;
      height: 100%;
      width: 100vw;
      top: 0;

      ${p => p.theme.breakpoints.down('xs')} {
        background-image: url(${Path});
        background-repeat: no-repeat;
        height: 224px;
        background-size: cover;
        width: 422px;
        left: auto;
        top: 50%;
        right: -165px;
        transform: translateY(-50%);
        z-index: 0;
        filter: brightness(0) invert(1);
      }
    }
  }

  .Hero__Text-Container {
    font-weight: bold;
    font-size: 56px;
    line-height: 64px;
    letter-spacing: -2px;
    margin-right: 114px;
    z-index: 2;
    position: relative;
    ${p => p.theme.breakpoints.down('md')} {
      margin-right: 12px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      margin-right: 4px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      margin-right: 0px;
    }
  }

  .Hero__Image-Container {
    width: 384px;
    height: 328px;
    position: relative;

    ${p => p.theme.breakpoints.down('sm')} {
      width: 360px;
      height: 265px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      display: none;
    }
  }

  .Hero__Image-Robot {
    object-fit: cover;
    height: 328px;
    padding: 16px;
    box-sizing: border-box;
    position: relative;
    z-index: 2;

    ${p => p.theme.breakpoints.down('sm')} {
      width: 265px;
      height: 265px;
    }
  }

  .Hero__Image-Path {
    filter: brightness(0) invert(1);
    z-index: 1;
    position: absolute;
    min-width: 678px;
    width: 678px;
    height: 319px;
    top: 0;
    left: -100px;
    ${p => p.theme.breakpoints.down('sm')} {
      min-width: 383.5px;
      width: 383.5px;
      height: 192px;
      left: -32px;
      top: 30px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      min-width: 327px;
      width: 327px;
      height: 164px;
      left: 0px;
      top: 0;
    }
  }
`
